// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2A-h0","left":"StickyBox_left__tpaHw","right":"StickyBox_right__3sRsJ"};